module.exports = __webpack_public_path__ + "img/7hearts.21c36f58.jpg";